/*
 * Copyright (c) 2026 SimplyBook.me Ltd. All rights reserved.
 * Licensed under the Apache License, Version 2.0.
 */

import React from "react";
import styled from "styled-components";
import Text from "../ui/Text";
import Title from "../ui/Title";
import Stack from "../ui/Stack";
import { useRovingTabIndex } from "../../hooks/a11y/useRovingTabIndex";
import { useTranslate } from "../../hooks/useTranslate";

const StyledPaymentProcessorsList = styled.ul`
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(155px, auto));
  gap: 1rem;
`;

const PaymentProcessorsList = ({ title, subtitle, children, ...props }) => {
  const { _t } = useTranslate();
  const childArray = React.Children.toArray(children);
  const defaultIndex = Math.max(0, childArray.findIndex((child) => child.props.selected));
  const { getItemProps } = useRovingTabIndex({
    count: childArray.length,
    orientation: "horizontal",
    defaultIndex,
  });

  return (
    <Stack $gap="1rem" {...props}>
      <Stack $gap="0.25rem" style={{ textAlign: "left" }}>
        {title && <Title size="h2">{title}</Title>}
        {subtitle && <Text color="dark">{subtitle}</Text>}
      </Stack>
      <StyledPaymentProcessorsList role="radiogroup" aria-label={_t(title)}>
        {childArray.map((child, index) => React.cloneElement(child, { rovingProps: getItemProps(index) }))}
      </StyledPaymentProcessorsList>
    </Stack>
  );
};

export default PaymentProcessorsList;
